import { camelCase } from "lodash";

export const snakeToCamelCase = (
    obj: Record<string, unknown> | unknown[],
): Record<string, unknown> | unknown[] => {
    if (Array.isArray(obj)) {
        return obj.map((item) => snakeToCamelCase(item as Record<string, unknown> | unknown[]));
    }
    if (obj !== null && typeof obj === "object") {
        return Object.keys(obj).reduce((acc, key) => {
            const camelCaseKey = camelCase(key);
            acc[camelCaseKey] = snakeToCamelCase(obj[key] as Record<string, unknown>);
            return acc;
        }, {} as Record<string, unknown>);
    }
    return obj;
};
